module.exports = __webpack_public_path__ + "img/binance.31088ce0.png";